import { render, staticRenderFns } from "./ServiceChargeManagement.vue?vue&type=template&id=0391275f&scoped=true"
import script from "./ServiceChargeManagement.vue?vue&type=script&lang=js"
export * from "./ServiceChargeManagement.vue?vue&type=script&lang=js"
import style0 from "./ServiceChargeManagement.vue?vue&type=style&index=0&id=0391275f&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0391275f",
  null
  
)

export default component.exports